import { render, staticRenderFns } from "./CopyHeader.vue?vue&type=template&id=f359bbd8&scoped=true"
import script from "./CopyHeader.vue?vue&type=script&lang=js"
export * from "./CopyHeader.vue?vue&type=script&lang=js"
import style0 from "./CopyHeader.vue?vue&type=style&index=0&id=f359bbd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f359bbd8",
  null
  
)

export default component.exports